import Vue from 'vue/dist/vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import NProgress from 'nprogress'
import VueMoment from 'vue-moment'
import MobileDetect from 'mobile-detect'
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueMoment)
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyCfI9L1rY1sEdjyzD40w7g8yrNaE05OG18' } })
Vue.baseUrl = "/api/frontend/V1";

import auth from './services/Client/Auth'

import App from './components/Client/App.vue'
import IndexView from './components/Shared/IndexView.vue'
import ProjectsView from './components/Client/ProjectsView.vue'
import ProjectView from './components/Client/ProjectView.vue'
import CompaniesView from './components/Shared/Company/CompaniesView.vue'
import CompanyView from './components/Shared/Company/CompanyView.vue'
import ContactsView from './components/Client/ContactsView.vue'
import ContactView from './components/Client/ContactView.vue'
import AlertsView from './components/Client/AlertsView.vue'
import CalendarView from './components/Shared/CalendarView.vue'
import NotesView from './components/Client/NotesView.vue'
import AccountView from './components/Client/AccountView.vue'
import SettingsView from './components/Client/SettingsView.vue'
import SubscriptionView from './components/Client/SubscriptionView.vue'
import ManualCenterView from './components/Client/ManualCenterView.vue'
import LoginView from './components/Client/LoginView.vue'
import ForgotPasswordView from './components/Client/ForgotPasswordView.vue'
import SignUpView from "./components/Client/SignUpView.vue";
import SignUpConfirmedView from "./components/Client/SignUpConfirmedView.vue";
import TrainingVideosView from "./components/Client/TrainingVideosView";

const md = new MobileDetect(window.navigator.userAgent);
const router = new VueRouter({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '/', name: 'default', component: IndexView},
        { path: '/sign-up', name: 'signup.choose', redirect: (() => {
            window.location.href = 'https://constructalead.com/sign-up/';
            return 'https://constructalead.com/sign-up/';
        }), meta: { guest: true} },
        { path: '/sign-up/:planId', name: 'signup.checkout', component: SignUpView, meta: { guest: true } },
        { path: '/sign-up/:planId/complete', name: 'signup.complete', component: SignUpConfirmedView },
        { path: '/Login', name: 'login', component: LoginView, meta: { guest: true } },
        { path: '/ForgotPassword', name: 'forgotpass', component: ForgotPasswordView, meta: { guest: true } },
        { path: '/ForgotPassword/:token', name: 'forgotpass.token', component: ForgotPasswordView, meta: { guest: true } },
        { path: '/Projects', name: 'projects', component: ProjectsView, meta: {title: 'Project search'} },
        { path: '/Me/Projects', name: 'projects.mine', component: ProjectsView, meta: {title: 'Saved projects'} },
        { path: '/Me/Projects/Tags/:tagId', name: 'projects.mine.tags', component: ProjectsView, meta: {title: 'Saved projects'} },
        { path: '/Projects/:projectId', name: 'projects.show', component: ProjectView },
        { path: '/Companies', name: 'companies', component: CompaniesView },
        { path: '/Companies/:companyId', name: 'companies.show', component: CompanyView },
        { path: '/Contacts', name: 'contacts', component: ContactsView, meta: {title: 'Directory'} },
        { path: '/Me/Contacts', name: 'contacts.mine', component: ContactsView, meta: {title: 'Saved contacts'} },
        { path: '/Me/Contacts/Tags/:tagId', name: 'contacts.mine.tags', component: ContactsView, meta: {title: 'Saved contacts'} },
        { path: '/Contacts/:contactId', name: 'contacts.show', component: ContactView },
        { path: '/Notes', name: 'notes', component: NotesView },
        { path: '/Alerts', name: 'alerts', component: AlertsView },
        { path: '/Calendar', name: 'calendar', component: CalendarView },
        { path: '/Me/Account', name: 'account', component: AccountView, meta: { user: true } },
        { path: '/Me/Settings', name: 'settings', component: SettingsView, meta: { user: true } },
        { path: '/Me/Subscription', name: 'subscription', component: SubscriptionView, meta: { user: true, title: 'Subscription' } },
        { path: '/Manual', name: 'help.manual', component: ManualCenterView },
        { path: '/TrainingVideos', name: 'help.vidoes', component: TrainingVideosView },
        { path: '/Logout', name: 'logout',
            beforeEnter (to, from, next) {
                auth.logout();
                next('/Login');
                location.reload();
            }
        },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {

    if (from.path != "/Login") {
        localStorage.setItem('prevPage', from.path);
    }

    if (!to.meta.guest && !auth.isLoggedIn()) {
        next({
            path: '/Login',
            query: { redirect: to.fullPath }
        })
    }
    else if (to.name === "login" && auth.isLoggedIn()) {
        next({ name: 'projects' })
    }
    else if (to.meta.guest && auth.isLoggedIn()) {
        next({ name: 'projects' })
    }
    else {
        next();
    }
});


Vue.http.interceptors.push((request, next) => {

    NProgress.start();

    const token = auth.getToken();
    Vue.http.headers.common["Authorization"] = 'Bearer ' + token;

    next((response) => {

        if (response.status == 401) {
            router.push({ name: 'logout' });
        }

        NProgress.done();
    });
});

auth.checkAuth();

const global = {
    auth: auth,
    isMobile: md.mobile() != null
}

const app = new Vue({
    el: '#app',
    router,
    render: h => h(App),
    data: global
})
